import React from 'react'
import { colors } from '@fs/zion-ui'

export default function MenuFeed({ selected = false, fillColor = colors.blue80 }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_13187_56705"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13187_56705)">
        <path
          d="M5.61538 10.6346C5.15513 10.6346 4.77083 10.4805 4.4625 10.1721C4.15417 9.86379 4 9.47949 4 9.01922V5.61537C4 5.15512 4.15417 4.77083 4.4625 4.4625C4.77083 4.15417 5.15513 4 5.61538 4H18.3846C18.8449 4 19.2292 4.15417 19.5375 4.4625C19.8458 4.77083 20 5.15512 20 5.61537V9.01922C20 9.47949 19.8458 9.86379 19.5375 10.1721C19.2292 10.4805 18.8449 10.6346 18.3846 10.6346H5.61538ZM5.61538 9.6346H18.3846C18.5641 9.6346 18.7115 9.57691 18.8269 9.46152C18.9423 9.34614 19 9.19871 19 9.01922V5.61537C19 5.43589 18.9423 5.28846 18.8269 5.17307C18.7115 5.05769 18.5641 5 18.3846 5H5.61538C5.43589 5 5.28846 5.05769 5.17308 5.17307C5.05769 5.28846 5 5.43589 5 5.61537V9.01922C5 9.19871 5.05769 9.34614 5.17308 9.46152C5.28846 9.57691 5.43589 9.6346 5.61538 9.6346ZM5.61538 20C5.15513 20 4.77083 19.8458 4.4625 19.5375C4.15417 19.2292 4 18.8449 4 18.3846V15C4 14.5398 4.15417 14.1555 4.4625 13.8471C4.77083 13.5388 5.15513 13.3846 5.61538 13.3846H18.3846C18.8449 13.3846 19.2292 13.5388 19.5375 13.8471C19.8458 14.1555 20 14.5398 20 15V18.3846C20 18.8449 19.8458 19.2292 19.5375 19.5375C19.2292 19.8458 18.8449 20 18.3846 20H5.61538ZM5.61538 19H18.3846C18.5641 19 18.7115 18.9423 18.8269 18.8269C18.9423 18.7115 19 18.5641 19 18.3846V15C19 14.8205 18.9423 14.6731 18.8269 14.5577C18.7115 14.4423 18.5641 14.3846 18.3846 14.3846H5.61538C5.43589 14.3846 5.28846 14.4423 5.17308 14.5577C5.05769 14.6731 5 14.8205 5 15V18.3846C5 18.5641 5.05769 18.7115 5.17308 18.8269C5.28846 18.9423 5.43589 19 5.61538 19Z"
          fill={selected ? fillColor : colors.gray100}
          fillOpacity={selected ? 1 : 0.5}
        />
      </g>
    </svg>
  )
}
